import { extend } from '@/common/core';
import * as i18n from './i18n';
extend(i18n);
